import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize, Observable } from 'rxjs';
import { AumicoCoreProvider } from '../../../../aumico-lib-core-fe/src/lib';
import { SsoOidcDto } from '../dtos/ssoOidcDto.interface';
import { RoutesUtil } from '../util/RoutesUtil';

@Injectable({
    providedIn: 'root',
})
export class SsoService {
    constructor(
        private http: HttpClient,
        private readonly coreProvider: AumicoCoreProvider,
        private routesUtil: RoutesUtil,
    ) {}

    public getSsoProvider(handle: string): Observable<SsoOidcDto> {
        this.coreProvider.dispatchBlockingRequest('[Aumico-SsoProvider] Get Sso Provider');
        const url = this.routesUtil.getSsoProvider(handle);
        return this.http
            .get<SsoOidcDto>(url)
            .pipe(
                finalize(() => this.coreProvider.dispatchBlockingRequestEnd('[Aumico-SsoProvider] Get Sso Provider')),
            );
    }
}
